import {bullCallSpread, BullCallSpread} from "./questions/BullCallSpreadPayoff";
import {marginCall, MarginCall} from "./questions/MarginCall";
import {marginedStrategies, MarginedStrategies} from "./questions/MarginedStrategies";
import {marketDownProtection, MarketDownProtection} from "./questions/MarketDownProtection";
import {moneyness, Moneyness} from "./questions/Moneyness";
import {premium, Premium} from "./questions/Premium";
import {atTheMoney, AtTheMoney} from "./questions/ShortAtTheMoneyCall";
import {shortCallExercised, ShortCallExercised} from "./questions/ShortCallExercised";
import {strikePrice, StrikePrice} from "./questions/StrikePrice";
import {volatility, Volatility} from "./questions/Volatility";
import {marginQuiz, MarginQuiz} from "./quiz/MarginQuizComponent";
import {marginQuizResults, MarginQuizResults} from "./results/MarginQuizResultsComponent";
import {MarginQuizService} from "./service/MarginQuizService";

export default angular.module("tfApp.quiz.margin-quiz", [])
                      .component(BullCallSpread, bullCallSpread())
                      .component(MarginCall, marginCall())
                      .component(MarginedStrategies, marginedStrategies())
                      .component(MarketDownProtection, marketDownProtection())
                      .component(Moneyness, moneyness())
                      .component(Premium, premium())
                      .component(AtTheMoney, atTheMoney())
                      .component(ShortCallExercised, shortCallExercised())
                      .component(StrikePrice, strikePrice())
                      .component(Volatility, volatility())
                      .component(MarginQuiz, marginQuiz())
                      .component(MarginQuizResults, marginQuizResults())
                      .service(MarginQuizService.id, MarginQuizService)
                      .name;
